module.exports = __webpack_public_path__ + "static/media/avnt-map-mockup.08022dc1.png";